import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VehicleConsecutiveDays } from '../models/vehicle-consecutive-days.model';
import { RestProvider } from './rest.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { IQueryParameters } from '../models/api-base-actions.interface';

@Injectable({
  providedIn: 'root',
})
export class VehicleConsecutiveDaysService {

  private baseApiUrl = environment.dataliveApiUrl;

  constructor(private rest : RestProvider){}

  getVehicleConsecutiveDays(queryParams: IQueryParameters): Observable<VehicleConsecutiveDays[]> {
    return this.rest.get<VehicleConsecutiveDays[]>(`${this.baseApiUrl}/utilization/vehicle_utilization_statistics/`, queryParams ? queryParams : undefined)
    .pipe(
      map((data : any) => {
        return Object.values(data)})
    );
  }

  getVehicleCategories(): Observable<any[]> {
    return this.rest.get<any[]>(`${this.baseApiUrl}/administration/driver_category/`)
  }
  
}
